import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import updateTxpFlag from '../actions/updateTxpFlag';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import TxpEventsPanel from './TxpEventsPanel';
var styles = require('./TxpOptions.scss');
var TxpFull = /** @class */ (function (_super) {
    tslib_1.__extends(TxpFull, _super);
    function TxpFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The event handler for the radio button to enable or disable txp
         */
        _this.eventsToEmailUpdated = function (ev, checked) {
            updateTxpFlag('EventsFromEmailEnabled', checked);
        };
        /**
         * The event handler behind the OptionsCheckbox for setting the CreateEventsFromEmailAsPrivate flag
         */
        _this.updateCreateEventsFromEmailAsPrivateFlag = function (ev, checked) {
            updateTxpFlag('CreateEventsFromEmailAsPrivate', checked);
        };
        return _this;
    }
    TxpFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var mailboxCalendarConfiguration = getCalendarConfiguration();
        if (!mailboxCalendarConfiguration) {
            return null;
        }
        // Initializing all the flags for the UI
        var EventsFromEmailEnabled = getFallbackValueIfNull(optionStore.EventsFromEmailEnabled, mailboxCalendarConfiguration.EventsFromEmailEnabled);
        var CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(optionStore.CreateEventsFromEmailAsPrivate, mailboxCalendarConfiguration.CreateEventsFromEmailAsPrivate);
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_txp_description),
            React.createElement(OptionsCheckbox, { label: strings.options_txp_enable, checked: !!EventsFromEmailEnabled ? true : false, onChange: this.eventsToEmailUpdated }),
            React.createElement("div", { className: styles.txpPrivateOption },
                React.createElement(OptionsCheckbox, { label: strings.options_txp_markEventsPrivate, checked: CreateEventsFromEmailAsPrivate, disabled: !EventsFromEmailEnabled, onChange: this.updateCreateEventsFromEmailAsPrivateFlag })),
            React.createElement(TxpEventsPanel, { formFlags: optionStore.Events, mailboxCalendarConfiguration: mailboxCalendarConfiguration, flagsDisabled: !EventsFromEmailEnabled })));
    };
    TxpFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
        })
    ], TxpFull);
    return TxpFull;
}(React.Component));
export default TxpFull;
//# sourceMappingURL=TxpFull.js.map